import {
  StorefrontIcon,
  FileArrowUpIcon,
  BuildingOfficeIcon,
  UsersIcon,
  ArrowBendDownRightIcon,
  UserCircleCheckIcon
} from "@phosphor-icons/react";

export const menuItems = [
  {
    path: "/companies",
    label: "Companies",
    icon: BuildingOfficeIcon
  },
  {
    path: "/talent-agencies",
    label: "Talent Agencies",
    icon: BuildingOfficeIcon
  },
  {
    path: "/talent-upload-request",
    label: "Talent Upload Requests",
    icon: FileArrowUpIcon
  },
  {
    path: "/creators",
    label: "Creators",
    icon: UserCircleCheckIcon
  },
  {
    path: "",
    label: "Marketplace",
    icon: StorefrontIcon,
    isSubMenu: true,
    subMenus: [
      {
        path: "/marketplace",
        label: "All Marketplace"
      },
      {
        path: "/campaign-report",
        label: "Campaigns Reported as Issues by Creators"
      }
    ]
  },
  {
    path: "",
    label: "Users (Brands)",
    icon: UsersIcon,
    isSubMenu: true,
    subMenus: [
      {
        path: "/marketer-users",
        label: "All Users"
      },
      {
        path: "/marketer-search-history",
        label: "Null Searches"
      }
    ]
  },
  {
    path: "",
    label: "Users (Creators)",
    icon: UsersIcon,
    isSubMenu: true,
    subMenus: [
      {
        path: "/creator-users",
        label: "All Users"
      },
      {
        path: "/creators-verification",
        label: "Instagram Connect - DM Flow"
      },
      // {
      //   path: "/brand-followers",
      //   label: "Low Follower"
      // }
    ]
  }
];
